import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableCellV2Component, templateDataTableCellV2 } from './DataTableCellV2';
import styles from './DataTableCellV2.styles.scss';
export const chameleonDataTableCellV2 = DataTableCellV2Component.compose({
    baseName: 'data-table-cell-v2',
    template: templateDataTableCellV2,
    styles: withStylePrefix(styles),
});
